export function solutionsSlider() {
    const $sliderWrapper = $(".solutions-block");
    const $slider = $(".solutions-slider");
    const $sliderTabs = $(".slider-tabs");
    const $sliderTab = $(".tags-item");
    const $sliderThumbnailsLength = $sliderTabs.find($sliderTab).length;
    const $window = $(window);
    let sliderThumbnailShow;

    function ThumbnailsCount() {
        if (window.innerWidth >= 1200) {
            sliderThumbnailShow = $sliderThumbnailsLength > 4 ? 4 : $sliderThumbnailsLength;
        } else {
            sliderThumbnailShow = $sliderThumbnailsLength > 2 ? 2 : $sliderThumbnailsLength;
        }
    }

    ThumbnailsCount();

    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        asNavFor: $sliderTabs,
        autoplay: true,
        autoplaySpeed: 6100,
        adaptiveHeight: true,
        mobileFirst: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    adaptiveHeight: false
                }
            }
        ]
    });
    $sliderTabs.slick({
        asNavFor: $slider,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        mobileFirst: true,
        infinite: false,
        variableWidth: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        slidesToShow: sliderThumbnailShow,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: sliderThumbnailShow,
                    slidesToScroll: 1,
                    variableWidth: false
                }
            }
        ]
    });
    $window.on("load resize", function () {
        let $slidesShown = $sliderTabs.slick("slickGetOption", "slidesToShow");
        if ($sliderThumbnailsLength <= $slidesShown) {
            setTimeout(() => {
                $sliderTabs.find(".slick-track").css("transform", "translate3d(0px, 0px, 0px)");
            }, 500);
        }
        setTimeout(function () {
            ThumbnailsCount();
        }, 500);
    });
    if ($window.width() < 1200) {
        $slider.on("touchstart", function (e) {
            $slider.slick("slickPause");
            $sliderTabs.find(".slick-current .tags-item").addClass("paused");
            $(this).one("touchend", function (e) {
                $(this).off("touchmove");
                $slider.slick("slickPlay");
                $sliderTabs.find($sliderTab).removeClass("paused");
            });
        });
    }

    function pauseSlider() {
        $slider.slick("slickPause");
        $sliderTabs.find(".slick-current .tags-item").addClass("paused");
    }

    function resumeSlider() {
        $slider.slick("slickPlay");
        $sliderTabs.find(".slick-current .tags-item").removeClass("paused");
    }

    if ($window.width() > 1200) {
        $slider.on("mousedown", function () {
            pauseSlider();
            $(document).one("mouseup", function () {
                resumeSlider();
            });
        });

        $slider.on("click", function () {
            pauseSlider();
        });

        $(document).on("click", function (e) {
            if (!$slider.is(e.target) && $slider.has(e.target).length === 0) {
                resumeSlider();
            }
        });
    }

    $window.on("load scroll", function () {
        let $winTop = $window.scrollTop();
        let $windowBottomPosition = ($winTop + $window.height());
        $slider.each(function () {
            let $this = $(this);
            let $sectionTop = $this.offset().top;
            if ($windowBottomPosition > $sectionTop) {
                $this.addClass("show");
                $slider.slick("slickPlay");
                $slider.find(".slick-current").addClass("active");
                $sliderTabs.find($sliderTab).removeClass("paused");
            } else {
                // $this.removeClass("show");
                $slider.slick("slickPause");
                $sliderTabs.find(".slick-current .tags-item").addClass("paused");
            }
        });
    });

    $slider.on("beforeChange", function (event, slick, currentSlide) {
        let $currentSlide = $(slick.$slides[currentSlide]);
        $currentSlide.removeClass("active");
    });
    $slider.on("afterChange", function (event, slick, currentSlide) {
        let $currentSlide = $(slick.$slides[currentSlide]);
        $currentSlide.addClass("active");
        if(currentSlide === $sliderThumbnailsLength - 1){
            setTimeout(function (){
                $slider.slick("slickGoTo",0);
                //$slider.slick('refresh');
            },6099);
        }
    });
    $slider.find(".cards-holder .item").each(function () {
        let $this = $(this);
        let text = $this.html();
        $this.html('<span>' + text + '</span>');
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/solutionsSlider.js